import { createContext, useContext, useEffect, useMemo, useState, useCallback } from "react";
import api from "../lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = loading, false = logged out
  const [token, setToken] = useState(localStorage.getItem("ill_token"));

  const refresh = useCallback(async () => {
    const t = localStorage.getItem("ill_token");
    if (!t) {
      setUser(false);
      return;
    }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch (e) {
      localStorage.removeItem("ill_token");
      setToken(null);
      setUser(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const setSession = useCallback((data) => {
    localStorage.setItem("ill_token", data.token);
    setToken(data.token);
    setUser(data.user);
  }, []);

  const login = useCallback(async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    setSession(data);
    return data.user;
  }, [setSession]);

  const register = useCallback(async (name, email, password, code) => {
    const { data } = await api.post("/auth/register", { name, email, password, code });
    setSession(data);
    return data;
  }, [setSession]);

  const logout = useCallback(() => {
    localStorage.removeItem("ill_token");
    setToken(null);
    setUser(false);
  }, []);

  const value = useMemo(
    () => ({ user, token, login, register, logout, refresh, setUser }),
    [user, token, login, register, logout, refresh]
  );

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
